module.exports = __webpack_public_path__ + "static/media/mreavesxlsannarr-020415006EmigreWebOnly.27d9c3af.ttf";